export const SYSTEM_CREATED_POSTER_TYPE = '系统创建';
